'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _entity = require('conversations-core/reducers/utils/entity');

var _entity2 = _interopRequireDefault(_entity);

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _immutable = require('immutable');

var _reduxActions = require('redux-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = new _immutable.Map();

exports.default = (0, _entity2.default)('messages', (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes2.default.CREATE_MESSAGE_SUCCEEDED, function (state, action) {
  var id = '' + action.payload.response.id;
  return state.set(id, action.payload.response);
}), _defineProperty(_handleActions, _ActionTypes2.default.DELETE_MESSAGE_SUCCEEDED, function (state, action) {
  var id = '' + action.payload.id;
  return state.delete(id);
}), _defineProperty(_handleActions, _ActionTypes2.default.UPDATE_MESSAGE_SUCCEEDED, function (state, action) {
  var message = action.payload.messageData;
  return state.set('' + message.id, message);
}), _defineProperty(_handleActions, _ActionTypes2.default.TOGGLE_MESSAGE_STATUS, function (state, action) {
  var id = '' + action.payload.id;

  var _state$get = state.get(id),
      active = _state$get.active;

  return state.setIn([id, 'active'], !active);
}), _handleActions), initialState));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/reducers/messages.js
// module id = 511
// module chunks = 0